/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DataForwardingRuleDto { 
    id?: number;
    deviceId?: number;
    destinationEmailAddress?: string;
    dataForwardingRuleType?: DataForwardingRuleDto.DataForwardingRuleTypeEnum;
}
export namespace DataForwardingRuleDto {
    export const DataForwardingRuleTypeEnum = {
        All: 'ALL',
        DataOnly: 'DATA_ONLY',
        AcknowledgesOnly: 'ACKNOWLEDGES_ONLY',
        None: 'NONE'
    } as const;
    export type DataForwardingRuleTypeEnum = typeof DataForwardingRuleTypeEnum[keyof typeof DataForwardingRuleTypeEnum];
}


export type DataForwardingRuleTypeEnum = typeof DataForwardingRuleDto.DataForwardingRuleTypeEnum[keyof typeof DataForwardingRuleDto.DataForwardingRuleTypeEnum];
